﻿import { Observable, Subject } from 'common/barrels/rx';
import { functionName } from 'common/reflection';

export abstract class Event {
    static eventName(): string {
        return functionName(this);
    }

    eventName(): string {
        return functionName(this.constructor);
    }
}

export class RequestEvent<TEvent, TResponse> extends Event {
    // without these variables the compiler will erase the generic types, which are used for type-checking down the line
    // because project references are used, these members must be at least protected (private will lead to erasure)
    protected hax1: TEvent;
    protected hax2: TResponse;
    public static IsRequest = true;

    constructor(public streaming = false) {
        super();
    }
}

export class RequestWrapper<TEvent extends Event, TResponse> {
    constructor(public payload: TEvent, public success: (result: TResponse) => void, public error: (error: any) => void, public cancel: Observable<any>, public results: Subject<TResponse>) { }

    eventName(): string {
        return `RequestWrapper<${this.payload.eventName()}>`;
    }

    static eventName(wrappedEventName: string): string {
        return `RequestWrapper<${wrappedEventName}>`;
    }
}